import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './UnreleasedApp.css';
import White1 from '../../assets/images/components/White1.png';
import White2 from '../../assets/images/components/White2.png';
import White3 from '../../assets/images/components/White3.png';
import White4 from '../../assets/images/components/White4.png';

const UnreleasedApp = () => {
    const navigate = useNavigate();
    const [selectedImage, setSelectedImage] = useState(null);
    const [user, setUser] = useState(JSON.parse(localStorage.getItem('dizeeUser')));

    // Array of all possible images
    const images = [
        White1,
        White2,
        White3,
        White4
    ];

    useEffect(() => {
        // Get the last displayed image path from localStorage
        const lastImage = localStorage.getItem('lastDisplayedUnreleasedImage');

        // Select a random image that's different from the last one
        let randomIndex;
        let newImage;

        do {
            randomIndex = Math.floor(Math.random() * images.length);
            newImage = images[randomIndex];
        } while (newImage === lastImage && images.length > 1);

        // Save the new image to localStorage for next time
        localStorage.setItem('lastDisplayedUnreleasedImage', newImage);

        // Set the selected image
        setSelectedImage(newImage);
    }, []);

    // Add useEffect for scroll prevention
    useEffect(() => {
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
        document.body.style.height = '100%';
        document.body.style.touchAction = 'none';

        return () => {
            document.body.style.overflow = 'unset';
            document.documentElement.style.overflow = 'unset';
            document.body.style.position = 'static';
            document.body.style.width = 'auto';
            document.body.style.height = 'auto';
            document.body.style.touchAction = 'auto';
        };
    }, []);

    const handleComingSoon = () => {
        // Navigate to the user's actual vault
        if (user && user.username) {
            navigate(`/vault/${user.username}`);
        } else {
            navigate('/vault/demo');
        }
    }

    return (
        <div className="unreleased-login-container">
            <div className="unreleased-mobile-frame">
                {/* Home button positioned at top right for mobile */}
                <div className="unreleased-home-button-container">
                    <span onClick={() => navigate('/')}
                        className='unreleased-home-button'>HOME</span>
                </div>
                <div className="unreleased-login-content">
                    <div className="unreleased-login-image-wrapper">
                        <div className="unreleased-image-container">
                            {selectedImage && (
                                <img
                                    src={selectedImage}
                                    alt="AI Art"
                                    className="unreleased-login-image"
                                />
                            )}
                            <div className="unreleased-image-gradient"></div>
                        </div>
                        <div className="unreleased-login-branding">
                            <p className="uppercase tracking-[3px] font-medium">U N R E L E A S E D</p>
                        </div>
                    </div>
                    <div className="unreleased-login-buttons !bottom-[-5px]">
                        <button
                            className="unreleased-login-button reduced-height"
                            onClick={handleComingSoon}
                        >
                            Explore Vault
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UnreleasedApp; 